import { NavItems } from '@shared/Frontend/components/navItems'
import { AsyncState, Maybe } from 'ballerina-core'

export type NavigationState = AsyncState<Maybe<NavItems>>

export const initialNavigationState: NavigationState = AsyncState.Default.unloaded()
